const CaseStudyObj = {
    container: null,
    background: null,
    backgroundSlider: null,
    button: null,
    buttonSlider: null,
    content: null,
    contentSlider: null,
    logo: null,
    logoSlider: null
}

export function CaseStudySliders(Slider, els) {
    const elements = Array.from(els)
    return elements.map((el) => createCaseStudySliders(Slider, el))
}

function createCaseStudySliders(Slider, el) {
    const Obj = Object.create(CaseStudyObj)
    init.call(Obj, Slider, el)
    return Obj
}

function init(Slider, el) {
    if (!el || !Slider) {
        return
    }

    this.container = el
    this.background = el.querySelector('.js-case-study-background-slider')
    this.content = el.querySelector('.js-case-study-content-slider')
    this.logo = el.querySelector('.js-case-study-logo-slider')
    this.button = el.querySelector('.js-case-study-button-slider')

    setupBackground.call(this, Slider)
    setupLogo.call(this, Slider)
    setupButton.call(this, Slider)
    setupContent.call(this, Slider)
}

function setupButton(Slider) {
    this.buttonSlider = Slider(this.button, {
        options: {
            horizontalSlide: true,
            isInfinite: true,
            animationSpeed: 1,
            liveRegion: false
        }
    })
}

function setupBackground(Slider) {
    this.backgroundSlider = Slider(this.background, {
        options: {
            isInfinite: true,
            fade: true,
            infiniteFade: true,
            liveRegion: false
        }
    })
}

function setupContent(Slider) {
    this.contentSlider = Slider(this.content, {
        options: {
            arrows: true,
            referenceArrows: true,
            dots: true,
            referenceDotContainer: true,
            isInfinite: true,
            horizontalSlide: true,
            itemName: 'Case studies',
            dotFormat: (x) => `<span class="u-visually-hidden">slide ${x}</span>`,
            navFor: [this.backgroundSlider, this.logoSlider, this.buttonSlider]
        }
    })
}

function setupLogo(Slider) {
    this.logoSlider = Slider(this.logo, {
        options: {
            isInfinite: true,
            horizontalSlide: true,
            liveRegion: false
        }
    })
}
